<template>
    <evp-layout>
        <navigation-header
            :return-url="route('help')"
            :title="title"
        />

        <div class="bg-surface shadow-small py-6 rounded-md mt-4">
            <article class="prose-sm md:prose-base" v-html="content" />
        </div>
    </evp-layout>
</template>

<script setup>
    import EvpLayout from '@/components/EvpLayout.vue'
    import { route } from 'ziggy'
    import NavigationHeader from '@/components/NavigationHeader.vue'

    const title = window.articleData.title
    const content = window.articleData.content
</script>